import React from 'react';
import PropTypes from 'prop-types';

import MultipleOptionsList from '@productConfig/components/MultipleOptionsList';
import ExclusiveOptionsList from '@productConfig/components/ExclusiveOptionsList';
import OptionList from '@productConfig/components/OptionList';
import { isNullOrUndefined } from '@utils/object';

// Simplify the filter function for better readability
const filterOptionsWithStock = options =>
  options?.filter(option => option?.hasStock);

// Create a function to generate filtered props to avoid code duplication
const getFilteredProps = props => ({
  ...props,
  optionGroup: {
    ...props?.optionGroup,
    options: filterOptionsWithStock(props?.optionGroup?.options),
  },
});
const selectByQuantity = (quantity, props) => {
  const filteredProps = getFilteredProps(props);

  if (quantity === 0) return <OptionList {...filteredProps} />;
  if (quantity === 1) return <ExclusiveOptionsList {...filteredProps} />;

  return <MultipleOptionsList {...filteredProps} />;
};

const selectByMinMaxQuantity = (quantity, minQuantity, maxQuantity, props) => {
  const filteredProps = getFilteredProps(props);

  if (minQuantity === 0) {
    if (maxQuantity === 0) {
      return selectByQuantity(quantity || minQuantity, filteredProps);
    }
    if (maxQuantity > 1) {
      return <MultipleOptionsList {...filteredProps} />;
    }

    return <OptionList {...filteredProps} />;
  }

  if (minQuantity === 1) {
    if (maxQuantity === 0 || maxQuantity === 1) {
      return <ExclusiveOptionsList {...filteredProps} />;
    }

    return <OptionList {...filteredProps} />;
  }

  return <MultipleOptionsList {...filteredProps} />;
};

function ProductOptionList(props) {
  const { optionGroup } = props;
  const { quantity, minQuantity, maxQuantity } = optionGroup;

  let component = null;

  if (isNullOrUndefined(minQuantity) && isNullOrUndefined(maxQuantity)) {
    component = selectByQuantity(quantity, props);
  } else if (!isNullOrUndefined(minQuantity)) {
    component = selectByMinMaxQuantity(
      quantity,
      minQuantity,
      maxQuantity,
      props,
    );
  }

  return component;
}

ProductOptionList.propTypes = {
  optionGroup: PropTypes.object.isRequired,
};

export default ProductOptionList;
